import { render } from "./AdmCadcomboView.vue?vue&type=template&id=6c8b7ced"
import script from "./AdmCadcomboView.vue?vue&type=script&lang=js"
export * from "./AdmCadcomboView.vue?vue&type=script&lang=js"

import exportComponent from "G:\\Projeto_ELITE\\VUE\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__